import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BookOpen, Mic, Sparkles, User, Wand2 } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { standEasyActive } from "../StandEasySkin";

const TABS = [
  { id: "create", label: "Create", to: "/my-installations", match: ["/my-installations", "/my-journeys"], Icon: Wand2 },
  { id: "signatures", label: "Signatures", to: "/signature-installations", match: ["/signature-installations"], Icon: Sparkles },
  { id: "library", label: "Library", to: "/my-library", match: ["/my-library"], Icon: BookOpen },
  { id: "voice", label: "My voice", to: "/voice-library", match: ["/voice-library"], Icon: Mic },
  { id: "account", label: "Account", to: "/soulumo/account", match: ["/soulumo/account"], Icon: User },
];
const H = "64px";
const on = (path, m) => m.some((p) => path === p || path.startsWith(p + "/"));

/* Soulumo's one way around: always visible on the member pages, so nobody gets lost. */
export default function SoulumoTabBar() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const { user } = useAuth();
  const show = !!localStorage.getItem("reclaim_token") && TABS.some((t) => on(pathname, t.match)) && !standEasyActive(pathname, user);
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--soulumo-tabbar", show ? H : "0px");
    document.body.style.paddingBottom = show ? `calc(${H} + env(safe-area-inset-bottom, 0px))` : "";
  }, [show]);
  if (!show) return null;
  return (
    <>
    <div aria-hidden className="fixed inset-0 pointer-events-none" style={{ zIndex: -1, background: "#091629" }} />
    <nav className="fixed inset-x-0 bottom-0 z-30" data-testid="soulumo-tabbar"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)", background: "rgba(9,22,41,0.92)", borderTop: "1px solid rgba(215,187,122,0.22)", backdropFilter: "blur(18px)" }}>
      <div className="max-w-2xl mx-auto grid grid-cols-5" style={{ height: H }}>
        {TABS.map(({ id, label, to, match, Icon }) => {
          const active = on(pathname, match);
          return (
            <button key={id} type="button" onClick={() => !(active && pathname === to) && nav(to)} data-testid={`soulumo-tab-${id}`}
              aria-current={active ? "page" : undefined}
              className="relative flex flex-col items-center justify-center gap-1 transition-colors duration-200"
              style={{ color: active ? "#d7bb7a" : "rgba(245,236,217,0.55)", fontFamily: '"Manrope", sans-serif' }}>
              {active && <span className="absolute top-0 h-[2px] w-8 rounded-full" style={{ background: "#d7bb7a" }} />}
              <Icon size={19} strokeWidth={active ? 2 : 1.6} />
              <span className="text-[0.58rem] uppercase tracking-[0.16em]">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
    </>
  );
}
